/*
 * Regels die op meer dan één formulier gelden.
 *
 * Het e-mailadres wordt op het aanvraagformulier én op het contactformulier
 * gevraagd, en de server keurt het op beide plekken met hetzelfde patroon en
 * dezelfde melding. Twee kopieën zouden vroeg of laat uiteenlopen, en dan zou een
 * adres op de ene pagina wel mogen en op de andere niet.
 *
 * De regels hier zijn gelijk aan `AanvraagValidator.cs` en `ContactValidator.cs`.
 */

/** Bovengrens per gewoon veld; beschermt de mail en de opslag tegen onzin. */
export const maximaleVeldlengte = 200

// Geen poging tot een volledige RFC 5322-controle: die is berucht om het afwijzen
// van geldige adressen. De echte controle is dat de mail aankomt.
const emailPatroon = /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/

/** Keurt een e-mailadres; leeg is een eigen melding, want dat leest anders. */
export function keurEmailadres(waarde: string): string | undefined {
  if (waarde.trim() === '') return 'Vul uw e-mailadres in.'

  return waarde.length <= maximaleVeldlengte && emailPatroon.test(waarde.trim())
    ? undefined
    : 'Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.'
}
